/* eslint-disable react/jsx-no-target-blank */
import {SidebarMenuItem} from '../../../../../../../_metronic/layout/components/sidebar/sidebar-menu/SidebarMenuItem'
import {SidebarMenuItemWithSub} from '../../../../../../../_metronic/layout/components/sidebar/sidebar-menu/SidebarMenuItemWithSub'
import {SidebarMenuTabsItem} from '../../../../../../../_metronic/layout/components/sidebar/sidebar-menu/SidebarMenuTabsItem'
import {useCentral} from '../../../../../hooks/useCentral'
import {useHoteleria} from '../../../../../hooks/useHoteleria'
import {TabModel} from '../../../../../models'

const SidebarMenuHoteleria = () => {
  const {addTab, changeTab, menu, tabs} = useHoteleria()
  const {changeTab: changeTabCentral, addTab: addTabCentral, tabs: tabsCentral} = useCentral()

  const addTabToContainer = (tab: TabModel) => {
    // Verificar si ya existe una pestaña con el mismo submenu
    const existingTabIndex = tabs.findIndex(
      (existingTab) => existingTab.submenu === tab.submenu && existingTab.vista === tab.vista
    )
    
    if (existingTabIndex !== -1) {
      // Si ya existe, simplemente activarla
      changeTab(existingTabIndex)
    } else {
      // Si no existe, agregar una nueva pestaña
      changeTab(addTab(tab))
    }
  }

  const addTabToContainerCentral = (index: number, tab: any) => {
    let obj = {
      id: tab.id,
      title: tab.title,
      showPanel: false,
      content: {
        headerPanel: tab.content.headerPanel,
      },
      closable: true,
      submenu: tab.submenu,
      idToEdit: '',
      loadingTable: false,
      deleted: false,
      updated: false,
      vista: tab.vista,
      vistaId: tab.vistaId,
      fromOtherApp: true,
    }
    
    // Verificar si ya existe una pestaña con el mismo submenu en Central
    const existingTabIndex = tabsCentral.findIndex(
      (existingTab) => existingTab.submenu === obj.submenu && existingTab.vista === obj.vista
    )
    
    if (existingTabIndex !== -1) {
      // Si ya existe, simplemente activarla
      changeTabCentral(existingTabIndex)
    } else {
      // Si no existe, agregar una nueva pestaña
      changeTabCentral(addTabCentral(obj))
    }
  }

  return (
    <>
      <div className='menu-item'>
        <div className='menu-content pt-8 pb-2'>
          <span className='menu-section text-muted text-uppercase fs-8 ls-1'>HOTELERÍA</span>
        </div>
      </div>
      {menu &&
        menu.length > 0 &&
        menu.map((item) => {
          // const existOptionItem = item.opciones ? true : false
          // const canListItem =
          //   existOptionItem && item?.opciones.some((item: any) => item.opcion === 'ACCESO')
          // const isShow = canListItem
          // if (!isShow) return <></>
          return (
            <SidebarMenuItemWithSub
              key={item.id}
              to='/crafted/accounts'
              title={item.name}
              icon='/media/icons/duotune/communication/com006.svg'
              fontIcon='bi-person'
            >
              {item.key === 'vdi'
                ? item.arraySubItem.map((subItem: any, index: any) => {
                    return (
                      <SidebarMenuItem
                        key={subItem.id}
                        to={subItem.path}
                        title={subItem.title}
                        hasBullet={true}
                        onClickHandler={() => addTabToContainerCentral(index, subItem)}
                      />
                    )
                  })
                : item.arraySubItem.map((subItem: any) => {
                    const existOption = subItem.opciones ? true : false
                    const canList =
                      existOption && subItem?.opciones.some((item: any) => item.opcion === 'ACCESO')
                    const isShow = canList
                    if (!isShow) return <></>
                    return (
                      <SidebarMenuTabsItem
                        key={subItem.id}
                        to='/central/clientes'
                        title={subItem.title}
                        hasBullet={true}
                        onClickHandler={() => addTabToContainer(subItem)}
                      />
                    )
                  })}
              {}
            </SidebarMenuItemWithSub>
          )
        })}
    </>
  )
}

export {SidebarMenuHoteleria}
